import { render, staticRenderFns } from "./UploadApp.vue?vue&type=template&id=37233421&scoped=true&"
import script from "./UploadApp.vue?vue&type=script&lang=js&"
export * from "./UploadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37233421",
  null
  
)

export default component.exports